/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Module } from '@msdyn365-commerce-modules/utilities';
import { IDefaInfoTileViewProps } from './defa-info-tile';

export default (props: IDefaInfoTileViewProps) => {
    const {
        title,
        text
    } = props;

    return (
        <Module {...props.infoTile}>
            {title}
            {text}
        </Module>
    );
};
